import type { EnvironmentId } from "@cmmd-forge/contracts";

import type { CloudProjectCatalogRow } from "../../cmmd/cmmdForgeRuntimeListResource";
import { classifyEnvironmentId } from "../../environments/environmentIdClassification";
import { getSavedEnvironmentRecord } from "../../environments/runtime/catalog";

/** Resolves the CMMD runtime that owns provider readiness for a submission target. */
export function resolveSubmissionRuntimeId(
  input: { readonly activeCloudCatalogRow: CloudProjectCatalogRow | null },
  environmentId: EnvironmentId,
): string | null {
  const savedRuntimeId = getSavedEnvironmentRecord(environmentId)?.runtimeId?.trim();
  if (savedRuntimeId) return savedRuntimeId;

  const selectedCloudRow = input.activeCloudCatalogRow;
  const legacyRuntimeId = classifyEnvironmentId(environmentId).legacyRuntimeId;
  const selectedRowMatchesEnvironment =
    selectedCloudRow !== null &&
    (selectedCloudRow.cmmdEnvironmentId === environmentId ||
      selectedCloudRow.environmentId === environmentId ||
      selectedCloudRow.runtimeId === legacyRuntimeId);
  return selectedRowMatchesEnvironment ? selectedCloudRow.runtimeId : legacyRuntimeId;
}
